import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import './index.css'
import './lib/i18n';

import PortfolioView from './pages/PortfolioView'

const isPortfolioRoute = window.location.pathname.includes('/p/');

if (isPortfolioRoute) {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/p/:resumeId" element={<PortfolioView />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
} else {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <HelmetProvider>
      <BrowserRouter>
        <App />
        <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#FAFAFA', /* --soft-white */
            color: '#333333', /* --slate-gray - Direct hex for Vercel */
            border: '1px solid #E5E7EB', /* --cool-gray */
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.12)',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#2F80ED', /* --electric-blue */
              secondary: '#FAFAFA', /* --soft-white */
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#FAFAFA', /* --soft-white */
            },
          },
          loading: {
            iconTheme: {
              primary: '#2F80ED',
              secondary: '#FAFAFA',
            },
          },
        }}
      />
    </BrowserRouter>
  </HelmetProvider>,
  )
} 